import { createContext, useState, useEffect, useContext } from "react"
import { decrypt } from "./CryptoUtil"
import { useGlobalContext, decryptUsername } from "./GlobalContext"

const LeaderboardContext = createContext()

export const LeaderboardProviderCQ9 = ({ children }) => {
  const { username } = useGlobalContext()
  const [leaderboardData, setLeaderboardData] = useState([])
  const [loadingBoard, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [playerPosition, setPlayerPosition] = useState(null)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const DEBUG = false

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  const getBonusByRank = (rank) => {
    const r = parseInt(rank, 10)
    if (r === 1) return 1000
    if (r === 2) return 800
    if (r === 3) return 500
    if (r >= 4 && r <= 10) return 300

    return 0
  }

  const maskUsernameExactKeepLast = (u) => {
    if (!u) return u

    const normalized = (u + "###########").slice(0, 11)
    const lastChar = u.slice(-2)

    return (
      normalized.slice(0, 5) + // first 5
      "**" +
      normalized.charAt(7) + // fixed pos
      "*" +
      lastChar // ALWAYS real last char
    )
  }

  const getPlayerPosition = () => {
    const storedUsername = decryptUsername(localStorage.getItem("username"))
    if (!storedUsername) return null

    if (DEBUG) {
      console.log("[DEBUG] Matching storedUsername:", storedUsername)
      console.log(
        "[DEBUG] Against leaderboard randomChars:",
        leaderboardData.map((e) => e.randomChars)
      )
    }

    const found = leaderboardData.find(
      (entry) => entry.randomChars === storedUsername
    )

    return found ? parseInt(found.ranking, 10) : null
  }

  // useEffect(() => {
  //   if (!isLoggedIn) return
  //   const fetchLeaderboardData = async () => {
  //     try {
  //       setLoading(true)
  //       const url = `${process.env.REACT_APP_API_JSON_URL_PROMO}?cmd=getCQ9Leaderboard`
  //       if (DEBUG) console.log("[DEBUG] Fetching leaderboard from:", url)

  //       const response = await fetch(url)
  //       if (!response.ok) throw new Error(`HTTP error: ${response.status}`)

  //       const rawData = await response.json()
  //       if (DEBUG) console.log("[DEBUG] Raw leaderboard data:", rawData)

  //       const parsedData = await Promise.all(
  //         Object.entries(rawData).map(async ([ranking, value]) => {
  //           const parts = value.split(",")
  //           const username = parts[0]?.trim()
  //           const freebets = parts[1]?.split("|")[1]?.trim() || "0"

  //           const encryptedRandom = parts[2]?.trim() || ""

  //           let randomChars = encryptedRandom
  //           let masked = encryptedRandom

  //           try {
  //             const decrypted = await decrypt(encryptedRandom)
  //             randomChars = decrypted
  //             masked = maskUsernameExactKeepLast(decrypted)
  //           } catch (e) {
  //             console.error("Decrypt error:", e)
  //           }

  //           if (DEBUG) {
  //             console.log(`[DEBUG] Rank ${ranking}:`, {
  //               username,
  //               freebets,
  //               randomChars,
  //               masked,
  //             })
  //           }

  //           return { ranking, username, freebets, randomChars, masked }
  //         })
  //       )

  //       if (DEBUG) console.log("[DEBUG] Parsed leaderboard data:", parsedData)
  //       setLeaderboardData(parsedData.slice(0, 20))
  //     } catch (err) {
  //       console.error("Leaderboard API error:", err)
  //       setError(err)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }
  //   fetchLeaderboardData()
  // }, [isLoggedIn])

  useEffect(() => {
    const pos = getPlayerPosition()
    if (pos !== null) setPlayerPosition(pos)
  }, [leaderboardData])

  return (
    <LeaderboardContext.Provider
      value={{
        leaderboardData,
        loadingBoard,
        error,
        getBonusByRank,
        getPlayerPosition,
        playerPosition,
      }}
    >
      {children}
    </LeaderboardContext.Provider>
  )
}

export const useLeaderboard = () => useContext(LeaderboardContext)
